function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { compose, bindActionCreators } from 'redux';
import { connectModal } from 'redux-modal';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { actions as toastrActions } from 'react-redux-toastr';
import * as shoppingCartActions from 'js/store/reducers/payment/shoppingCart/actions';
import * as userAuthActions from 'js/store/reducers/auth/user/actions';
import ShoppingCartModal from 'js/components/organisms/Modals/ShoppingCart';
var actions = [shoppingCartActions, userAuthActions];

function mapDispatchToProps(dispatch) {
  var _Map;

  var creators = (_Map = Map()).merge.apply(_Map, actions).filter(function (value) {
    return typeof value === 'function';
  }).toObject();

  var toastr = Map().merge(toastrActions).filter(function (value) {
    return typeof value === 'function';
  }).toObject();
  return {
    shoppingCart: bindActionCreators(creators, dispatch),
    toastr: bindActionCreators(toastr, dispatch),
    dispatch: dispatch
  };
}

function mapStateToProps(state) {
  return _objectSpread({}, state, {
    auth: state.user
  });
}

export default compose(connect(mapStateToProps, mapDispatchToProps), connectModal({
  name: 'ShoppingCartModal',
  destroyOnHide: false
}))(ShoppingCartModal);